import {JournalPopout} from "./app/app.js";
import {initConfig} from "./config.js";
import { registerSettings } from "./settings.js";

export const MODULE_ID = "journal-page-popout";

Hooks.on("init", () => {
    initConfig();
    registerSettings();

    Object.defineProperty(JournalEntryPage.prototype, "createPopout", {
        value: function () {
            new JournalPopout(this, []).render(true);
        }
    });
});